import { QShortcut } from "./QShortcut";
import { QXMLObject } from "./QXMLObject";
import { sortshortc } from "../utils/sortshortc";

export class QShortcutMgr extends QXMLObject {
  constructor() {
    super();
    this.fShortcutsActive = false;
    this.fShortcutList = null;
    this.fParentDoc = null;
    this.fTargetShortCut = null;
  }

  InitShortcutMgr(parentDoc) {
    this.fShortcutList = [];
    this.fParentDoc = parentDoc;
    this.SetXMLElementName("shortcutmgr");
  }

  //   var dataObj = shortcut.GetDataObj();
  //   if (dataObj != null) {
  //     wsMgr.NavToBox(dataObj, true);
  //   } else if (gWSMgr.GetDoc().IsServerChart()) {
  //     var refValue = shortcut.fShortcutObjID;
  //     var treeID = shortcut.fShortcutTreeID;
  //     if (treeID !== gSvrChartMgr.fTreeID && !docMgr.IsPlanChart()) {
  //       gSvrChartMgr.PersistFH(wsMgr.GetDoc());
  //       wsMgr.GetChartMetadata(refValue);
  //     } else wsMgr.DoChartDataQuery(refValue);
  //   }
  // };
  GetNumShortcuts() {
    return this.fShortcutList.length;
  }

  GetIndexShortcut(index) {
    return this.fShortcutList[index];
  }

  SortShortcuts() {
    this.fShortcutList.sort(sortshortc);
  }

  AddShortcutByVal(shortcutVal, anObj) {
    var parts = shortcutVal.split("|");
    var n = parts.length;
    for (var i = 0; i < n; i++) {
      var shortCut = new QShortcut();
      shortCut.InitShortcut(parts[i], anObj);
      this.AddShortcut(shortCut);
    }
  }

  AddShortcut(aShortcut) {
    var found = true;
    if (aShortcut.GetDataObj() == null) found = aShortcut.WireShortcut(this.fParentDoc);

    if (found) this.fShortcutList.push(aShortcut);
  }

  LoadFromJSON(json) {
    var shortcutList = json["shortcutList"];
    for (var i = 0; i < shortcutList.length; i++) {
      var shortcutInfo = shortcutList[i];
      var aShortcut = new QShortcut();
      aShortcut.DoInitShortcut();
      aShortcut.LoadFromJSON(shortcutInfo);
      this.AddShortcut(aShortcut);
    }

    return { shortcutList: shortcutList };
  }

  OutputToJSON(stream) {
    var shortcutList = [];
    var n = this.GetNumShortcuts();
    for (var i = 0; i < n; i++) {
      var indexShortcut = this.GetIndexShortcut(i);
      shortcutList.push(indexShortcut.OutputToJSON(stream));
    }

    return { shortcutList: shortcutList };
  }

  OutputChildElements(stream) {
    var n = this.GetNumShortcuts();
    for (var i = 0; i < n; i++) {
      var indexShortcut = this.GetIndexShortcut(i);
      indexShortcut.OutputToXML(stream);
    }
  }

  LoadSubElements(objTree) {}

  LoadChildElements(objTree) {
    var childList = objTree.GetChildOfTypeList("shortcut");
    var numShortcuts = childList.length;
    for (var i = 0; i < numShortcuts; i++) {
      var shortcutInfo = childList[i];
      var aShortcut = new QShortcut();
      aShortcut.DoInitShortcut();
      aShortcut.LoadFromXML(shortcutInfo);
      this.AddShortcut(aShortcut);
      //this.fShortcutList.push(aShortcut);
    }
  }

  GetShortcutList() {
    return this.fShortcutList;
  }

  GetActive() {
    return this.fShortcutsActive;
  }

  SetActive(isActive) {
    this.fShortcutsActive = isActive;
  }
}
